export const VOICE_RMS = 0.02;
export const CHUNK_VOICED_MS = 150;

export const isVoiced = (rms: number) => rms >= VOICE_RMS;

export const rms = (samples: ArrayLike<number>) => {
  let sum = 0;
  for (let i = 0; i < samples.length; i++) sum += samples[i] * samples[i];
  return samples.length ? Math.sqrt(sum / samples.length) : 0;
};

export const emptyTally = (chunks: number) => Array.from({ length: chunks }, () => 0);

export const addVoice = (tally: number[], chunk: number, ms: number) => {
  if (chunk >= 0 && chunk < tally.length) tally[chunk] += ms;
};

export const voicedCount = (tally: readonly number[]) => tally.filter((ms) => ms >= CHUNK_VOICED_MS).length;

export const voicedRatio = (tally: readonly number[]) =>
  tally.length ? Math.round((voicedCount(tally) / tally.length) * 100) / 100 : 0;

export const gapFinished = (g: { elapsedMs: number; voicedMs: number; silentMs: number }) =>
  g.elapsedMs >= 600 && g.voicedMs >= 200 && g.silentMs >= 450;
